import classnames from "classnames";
import type { FC } from "preact/compat";
import { CaretDownIcon } from "@components/Icons/CaretDownIcon";

export type RoundedComboboxBtnProps = {
  name?: string;
  labels?: string[];
  placeholder?: string;
  onClick?: (event: MouseEvent) => void;
  open?: boolean;
  multiSelectLabel?: string;
  error?: string;
  selectLater?: {
    value: string;
    label: string;
    selected?: boolean;
  };
};

export const RoundedComboboxBtn: FC<RoundedComboboxBtnProps> = ({
  labels: label,
  onClick,
  open,
  placeholder = "your state",
  multiSelectLabel = "Specialty",
  selectLater,
  error,
}) => {
  return (
    <div
      aria-label={open ? "close menu" : "open menu"}
      role='combobox'
      aria-expanded={open === true ? "true" : "false"}
      aria-haspopup='listbox'
      class='flex flex-col'
    >
      <button
        type='button'
        className={classnames(
          `relative flex cursor-pointer items-center justify-between truncate px-4 text-sm max-w-[540px] sm:max-w-[240px] rounded-3xl text-gt-black py-2 ${
            open || label?.length || selectLater?.selected
              ? "border-2 bg-white"
              : "border bg-transparent"
          } `,
          {
            "border-gt-lilac-dark": open,
            "border-2 bg-white border-[#B35436]": error,
            "border-gt-black": !error,
          },
        )}
        role='button'
        aria-label='open menu'
        aria-haspopup='true'
        data-toggle='true'
        onClick={onClick}
      >
        <div className='flex w-full items-center justify-between gap-2'>
          <span className='flex items-center truncate'>
            {selectLater?.selected && !label?.length ? (
              <span className='truncate'>{selectLater.label}</span>
            ) : label?.length ? (
              <span className='truncate'>
                {label.length > 1
                  ? `${multiSelectLabel} (${label.length})`
                  : label[0]}
              </span>
            ) : (
              <span className='truncate'>{placeholder}</span>
            )}
          </span>
          <CaretDownIcon open={open} />
        </div>
      </button>
      {error && (
        <div class='absolute top-full flex min-w-max text-xs text-[#B35436] items-center justify-center py-1'>
          <svg
            aria-hidden='true'
            focusable='false'
            data-prefix='fas'
            data-icon='diamond-exclamation'
            role='img'
            xmlns='http://www.w3.org/2000/svg'
            viewBox='0 0 512 512'
            height={10}
            width={10}
          >
            <path
              fill='currentColor'
              d='M227.7 11.7c15.6-15.6 40.9-15.6 56.6 0l216 216c15.6 15.6 15.6 40.9 0 56.6l-216 216c-15.6 15.6-40.9 15.6-56.6 0l-216-216c-15.6-15.6-15.6-40.9 0-56.6l216-216zM256 128c-13.3 0-24 10.7-24 24V264c0 13.3 10.7 24 24 24s24-10.7 24-24V152c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z'
            ></path>
          </svg>
          <span class='ml-1'>{error}</span>
        </div>
      )}
    </div>
  );
};
